export interface IPropertiesReq {
  libraryGuid: number;
  number: number;
  version: number;
}
